import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiHome, FiSearch, FiBookmark, FiUser } from 'react-icons/fi';

const BottomNavigation = () => {
    const navItems = [
        { name: 'Home', icon: FiHome, path: '/' },
        { name: 'Search', icon: FiSearch, path: '/search' },
    ];

    return (
        <nav className="fixed bottom-0 left-0 w-full h-16 bg-brand-dark/80 backdrop-blur-md border-t border-gray-800 flex items-center justify-around md:hidden z-50 px-2 shadow-2xl bottom-nav">
            {navItems.map((item) => (
                <NavLink
                    key={item.name}
                    to={item.path}
                    className={({ isActive }) =>
                        `flex flex-col items-center justify-center gap-1 min-w-[64px] transition-colors duration-300 ${isActive ? 'text-white' : 'text-gray-500'
                        }`
                    }
                >
                    <item.icon size={22} />
                    <span className="text-[10px] font-medium uppercase tracking-wider">{item.name}</span>
                </NavLink>
            ))}
        </nav>
    );
};

export default BottomNavigation;
